import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';
import { CONTACT_EMAIL } from '../constants/contact';

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      title="Política de privacidade"
      lastUpdated={new Date().toLocaleDateString('pt-PT', { year: 'numeric', month: 'long', day: 'numeric' })}
    >
      <h2>1. Introdução</h2>
      <p>
        A NeoDrive (&quot;nós&quot;, &quot;nos&quot; ou &quot;nosso&quot;) disponibiliza ferramentas de software como
        serviço para empresas de estafetas e operadores de frota. Esta Política de Privacidade explica como recolhemos,
        utilizamos, divulgamos e protegemos informações quando visita o nosso sítio web, utiliza as nossas aplicações ou
        interage com os nossos serviços.
      </p>

      <h2>2. Dados que tratamos</h2>
      <p>Podemos tratar as seguintes categorias de dados:</p>
      <ul>
        <li>
          <strong>Dados de conta e contacto:</strong> nome, endereço de correio eletrónico, número de telefone, nome da
          empresa, morada de faturação e credenciais de autenticação que nos fornece ao registar-se ou gerir a sua
          conta.
        </li>
        <li>
          <strong>Dados operacionais:</strong> informações que a sua organização introduz na plataforma (por exemplo
          registos de estafetas ou motoristas, relatórios, metadados relacionados com pagamentos) conforme necessário
          para prestar o serviço que configura.
        </li>
        <li>
          <strong>Dados técnicos:</strong> endereço IP, tipo de navegador, identificadores de dispositivo, registos de
          sistema e cookies ou tecnologias semelhantes, conforme descrito na nossa Política de Cookies.
        </li>
        <li>
          <strong>Dados de pagamento:</strong> tratados pelos nossos prestadores de pagamentos; não armazenamos números
          completos de cartão nos nossos servidores.
        </li>
      </ul>

      <h2>3. Como utilizamos os seus dados</h2>
      <p>Utilizamos dados pessoais para:</p>
      <ul>
        <li>Fornecer, manter e melhorar os produtos e funcionalidades NeoDrive;</li>
        <li>Autenticar utilizadores, proteger contas e prevenir fraude ou abuso;</li>
        <li>Comunicar sobre o serviço, faturação e avisos importantes;</li>
        <li>Cumprir obrigações legais e fazer cumprir os nossos Termos de utilização.</li>
      </ul>

      <h2>4. Fundamentos jurídicos (EEE/Reino Unido)</h2>
      <p>
        Quando aplicável, baseamo-nos na execução de contrato, interesses legítimos (como a segurança dos nossos
        serviços e a melhoria da usabilidade), consentimento quando exigido (por exemplo determinados cookies ou
        marketing) e obrigação legal.
      </p>

      <h2>5. Partilha e subcontratantes</h2>
      <p>
        Podemos partilhar dados com prestadores de serviços de confiança (alojamento, envio de correio eletrónico,
        análises, processamento de pagamentos) ao abrigo de acordos rigorosos. Podemos divulgar informação se a lei o
        exigir ou para proteger direitos, segurança e integridade. Operações societárias (por exemplo fusões) podem
        implicar transferência lícita de informação com salvaguardas adequadas.
      </p>

      <h2>6. Transferências internacionais</h2>
      <p>
        Se os dados forem transferidos para fora do seu país, implementamos salvaguardas adequadas (como Cláusulas
        Contratuais-Tipo) quando a lei aplicável o exige.
      </p>

      <h2>7. Conservação</h2>
      <p>
        Conservamos dados pessoais apenas pelo tempo necessário às finalidades descritas, salvo período mais longo
        exigido por lei ou necessidades empresariais legítimas (por exemplo registos de faturação e fiscais).
      </p>

      <h2>8. Os seus direitos</h2>
      <p>
        Conforme a sua localização, pode ter direitos de acesso, retificação, apagamento, limitação ou oposição ao
        tratamento, portabilidade dos dados e retirada do consentimento. Pode também apresentar reclamação junto de uma
        autoridade de controlo. Para exercer os seus direitos, contacte-nos pelos dados abaixo.
      </p>

      <h2>9. Segurança</h2>
      <p>
        Implementamos medidas técnicas e organizativas destinadas a proteger dados pessoais. Nenhum método de
        transmissão na Internet é totalmente seguro; esforçamo-nos por seguir práticas da indústria adequadas à
        natureza dos dados que tratamos.
      </p>

      <h2>10. Crianças</h2>
      <p>
        A NeoDrive não se dirige a crianças com menos de 16 anos. Não recolhemos conscientemente dados pessoais de
        crianças.
      </p>

      <h2>11. Alterações</h2>
      <p>
        Podemos atualizar esta Política de Privacidade periodicamente. Publicaremos a versão revista nesta página e
        atualizaremos a data de &quot;Última atualização&quot; quando apropriado.
      </p>

      <h2>12. Contacto</h2>
      <p>
        Para questões ou pedidos relacionados com privacidade, contacte-nos em{' '}
        <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
      </p>
    </LegalPageLayout>
  );
}
